import React, { PureComponent } from 'react';
import { connect } from "react-redux";

import NavigationArrow from "./arrow";

export class ContentNavigationContainer extends PureComponent {
    render(){
        return(
            <div>
                {this.props.schedules && this.props.schedules.length > 0
                ?
                <div className="content__navigation-container" style={{justifyContent: this.props.offset === 0 ? "flex-end" : ""}}>
                    { this.props.offset > 0 ? 
                        <NavigationArrow 
                        direction={"back"} 
                        text={<span>&larr; предыдущая неделя</span>}
                        offset={this.props.offset} 
                        /> 
                        : null }
                    <NavigationArrow 
                        direction={"forward"} 
                        text={<span>следующая неделя &rarr;</span>}
                        offset={this.props.offset}
                        />
                </div>
                : <div></div> }
            </div>
        );
    }
}

export default connect(state => ({
    offset: state.AppointmentReducer.offset,
    schedules: state.AppointmentReducer.schedules,
}))(ContentNavigationContainer);



// WEBPACK FOOTER //
// frontend/src/modules/appointment-table/nav/index.jsx